import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { DeleteToken } from '../../../../../core/shared/actions/token.actions';
import { ConfirmationModalComponent } from '../../../../../core/shared/components/modals/confirmation-modal/confirmation-modal.component';
import { Token } from '../../../../../core/shared/models/token.model';

@Component({
  selector: 'app-admin-token-modal',
  standalone: true,
  templateUrl: './admin-token-modal.component.html',
  styleUrl: './admin-token-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, MatSnackBarModule, MatFormField, MatLabel, MatInput, MatIcon, MatButton, MatIconButton, MatSlideToggleModule],
})
export class AdminTokenModalComponent implements OnInit {
  @Input() public token!: Token;
  @Input() public formMode = 'New';
  @Input() public editToken = false;
  private readonly formSubscription: Subscription = new Subscription();

  entryForm!: FormGroup;

  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private readonly formBuilder: FormBuilder,
    private readonly store: Store,
    private readonly snackBar: MatSnackBar
  ) {
    this.createForm();
  }

  ngOnInit() {
    const token = this.token;
    if (token) {
      this.entryForm.patchValue({
        PK: token.PK,
        SK: token.SK,
        Token: token.Token,
        CreationDate: token.CreationDate,
        Enabled: token.Enabled,
      });

      this.editToken = true;
    } else {
      this.editToken = false;
    }
  }

  openConfirmModal(message: string) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {});
    modalRef.componentInstance.message = message;
    modalRef.result.then((event: string) => {
      if (event === 'confirm') {
        this.onDelete();
      }
    });
  }

  onDelete() {
    this.formSubscription.add(
      this.store.dispatch(new DeleteToken(this.entryForm.controls['Token'].value)).subscribe(
        () => {
          this.activeModal.close();
          this.showSnackBar('The Token has been successfully deleted!!', false);
        },
        (error) => {
          this.activeModal.close();
          this.showSnackBar('An error occurred:' + error.error.message, true);
        }
      )
    );
  }

  private createForm() {
    this.entryForm = this.formBuilder.group({
      Token: [''],
      CreationDate: [''],
      Enabled: [''],
    });
  }

  showSnackBar(message: string, isError: boolean): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      panelClass: isError ? 'error-snackbar' : 'success-snackbar',
    });
  }

  clearForm() {
    this.entryForm.reset();
  }
}
